<app-card [isHeader]=true [title]="'search_filter'|translate">


    <form (ngSubmit)="submit()" [formGroup]="form" style="    flex-direction: column;
">
        <div class="cp5" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">

            <div fxFlex="25" fxFlex.lt-md="100">
                <app-text-field


                        [control]="getFormControl('bidNo')"
                        [label]="labels.bidNo | translate"
                ></app-text-field>
            </div>
            <ng-container *ngIf="getlang()==='fr'">
                <div fxFlex="25" fxFlex.lt-md="100">
                    <app-text-field
                            [control]="getFormControl('bidNmFr')"
                            [label]="labels.bidNmFr | translate"
                    ></app-text-field>
                </div>
            </ng-container>
            <div *ngIf="getlang()==='ar'" fxFlex="25" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('bidNmAr')"
                        [label]="labels.bidNmFr | translate"
                ></app-text-field>
            </div>
            <div fxFlex="25" fxFlex.lt-md="100">
                <app-combo-acheteur [control]="getFormControl('bidInstNm')"
                                    [label]="labels.bidInstCd | translate"></app-combo-acheteur>
            </div>
            <div *ngIf="getlang()==='fr'" fxFlex="25" fxFlex.lt-md="100">
                <app-select-common [code]="commmCode.procedure" [control]="getFormControl('procedureTypeStrFr')"
                                   [label]="labels.procedureTypeStrFr "
                                   [withcommonid]="true"
                                   [withfiltre]="true"></app-select-common>
            </div>


            <div *ngIf="getlang()==='ar'" fxFlex="25" fxFlex.lt-md="100">
                <app-select-common [code]="commmCode.procedure" [control]="getFormControl('procedureTypeStrAr')"
                                   [label]="labels.procedureTypeStrFr"
                                   [withcommonid]="true" [withfiltre]="true"></app-select-common>
            </div>
        </div>
        <div
                *ngIf="panelOpenState" class="cp5" fxFlex="100" fxLayout="row wrap"
                fxLayoutAlign="start center">
            <div *ngIf="getlang()==='fr'" fxFlex="50" fxFlex.lt-md="100">


                <app-combo-commande [code]="commmCode.categorieActivite" [controlFils]="getFormControl('bizKindStrFr')"
                                    [control]="getFormControl('pbkStrFr')"
                                    [label]="labels.pbkStrFr | translate"
                                    fxFlex.lt-md="100"></app-combo-commande>
            </div>
            <div *ngIf="getlang()==='ar'" fxFlex="50" fxFlex.lt-md="100">
                <app-combo-commande [code]="commmCode.categorieActivite"
                                    [controlFils]="getFormControl('bizKindStrAr')"
                                    [control]="getFormControl('pbkStrAr')"
                                    [label]="labels.pbkStrFr | translate"></app-combo-commande>
            </div>


            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-common [code]="commmCode.financement" [control]="getFormControl('financialMethodStrFr')"
                                   [label]="labels.financialMethodStrFr " [withcommonid]="true"
                                   [withcommonid]="true"
                                   [withfiltre]="true"></app-select-common>
            </div>
            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-common [code]="commmCode.lieu" [control]="getFormControl('executionPlaceStrFr')"
                                   [label]="labels.executionPlaceStrFr"
                                   [withcommonid]="true" [withfiltre]="true"></app-select-common>
            </div>
            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-common [code]="commmCode.onoff" [control]="getFormControl('onOffTypeStrId')"
                                   [label]="labels.planNo"
                                   [withcommonid]="true" [withfiltre]="true"></app-select-common>
            </div>


            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('publicDt')"
                        label="aprés cette date publication"
                ></app-select-date>

            </div>
            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('publicDt_end')"
                        label="avant cette date publication"
                ></app-select-date>

            </div>


            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('bdRecvEndDt')"
                        label="avant cette dernier délai réception offres"
                ></app-select-date>

            </div>
            <div fxFlex="25" fxFlex.lt-md="100">
                <app-select-date
                        [control]="getFormControl('bdRecvEndDt_end')"
                        label="aprés cette dernier délai réception offres"
                ></app-select-date>

            </div>

        </div>


        <div fxLayoutAlign="end end">
            <div>
                <button
                        class="filter-btn"
                        color="primary"
                        mat-flat-button
                        style="background-color: #3498db;"
                        type="submit"
                >
                    <mat-icon>{{ icons.search }}</mat-icon>
                    <span translate>search</span>
                </button>
            </div>
            <div style="margin-left: 1%;margin-right: 1%;">
                <button
                        (click)="reset()"
                        class="filter-btn"
                        color="primary"
                        mat-flat-button
                        type="submit"


                >
                    <mat-icon>{{ icons.reset }}</mat-icon>
                    <span translate>reset</span>
                </button>

            </div>
            <div>
                <a (click)="panelOpenState=!panelOpenState"
                   *ngIf="panelOpenState==true"
                   class="filter-btn"
                   mat-flat-button style="background-color: #FFFFFF;
        ">
                    <mat-icon>remove_circle_outline</mat-icon>
                </a>
                <a
                        (click)="panelOpenState=!panelOpenState"
                        *ngIf="panelOpenState==false"
                        class="filter-btn"
                        mat-flat-button style="background-color: #FFFFFF;
        ">
                    <mat-icon>add_circle_outline</mat-icon>
                </a>
            </div>
        </div>


    </form>

</app-card>
